export const countDecimalPoints = (n) => {
    const decimalPart = n.toString().split('.')[1];
    return decimalPart ? decimalPart.length : 0;
};
